<template>
  <template v-if="!StandAlonePages.includes(currRouteName)">
    <div class="container-fluid container-fluid-padding">

      <header-top></header-top>
      <header-menu :menu-data="menu"></header-menu>

      <router-view></router-view>

      <footer-container>
          <template #purchase-declaration-link>
            <a data-bs-toggle="modal" data-bs-target="#purchaseDeclarationModal" href="#" target="_blank">
              {{ $t('purchase_declaration') }}
            </a>
          </template>
        <template #privacy-link>
            <a data-bs-toggle="modal" data-bs-target="#privacyModal" href="#" target="_blank">
              {{ $t('privacy_policy') }}
            </a>
          </template>
          <template #cookies-link>
            <a data-bs-toggle="modal" data-bs-target="#cookiesModal" href="#" target="_blank">
              {{ $t('cookies_consent') }}
            </a>
          </template>
      </footer-container>
    </div>

  <!--  modal for session ending-->
    <SessionEndComponent
        class="container container-choose-route d-flex flex-column align-items-center"
        v-if="store.state.customer.sessionEnd">
    </SessionEndComponent>
  </template>

  <template v-else>
    <router-view></router-view>
  </template>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {useStore} from "vuex";
// @ts-ignore
import {routesConst} from './routes';

// @ts-ignore
import LanguageService from "./services/languageService";
// @ts-ignore
import apiService from "./services/apiService";
// @ts-ignore
import type {IApiResponseGeneral} from "./interfaces/apiResponseInterfaces/IApiResponseGeneral.interface";
import axios from "axios";
// axios.defaults.headers.common['Authorization'] = localStorage.getItem('token') ?? '';
// @ts-ignore
import {OrderModuleEvents} from "./interfaces/enums/OrderModuleEvents.enum";
// @ts-ignore
import SessionEndComponent from "../js/components/SessionEndModal/SessionEndComponent.vue";
import authService from './services/authService';
import RentService from "./services/rentService";
import {StandAlonePages} from "./routes";
import NameOfHelper from "./helpers/nameOfHelper";

export default defineComponent({
  components: {
    SessionEndComponent,
  },
  setup() {
    const store = useStore();

    return {
      store
    };
  },
  data() {
    return {
      logoUrl: null,
      companyPhone: null,
      menu: [],
      currRouteName: this.$route.name,
      StandAlonePages: StandAlonePages
    };
  },
  methods: {
    /**
     * Used when we get state data from iframe redirect, from one site to another to feed the state accordingly
     */
    handleGivenState(): void {
      const nameOf = (c) => NameOfHelper.obj(c);

      // Handle given state from iframe
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      if (urlParams.toString().length) {
        const state = urlParams.get('state');

        if (! state) {
          return;
        }

        const stateData = JSON.parse(decodeURIComponent(atob(state)));

        // ORDER STATE init
        let payload = <{prop: string, value: any}[]>[];

        let data = stateData.orderState;
        for (const prop in data) {
          if (! data.hasOwnProperty(prop)) {
            continue;
          }
          payload.push({
            prop, value: data[prop]
          });
        }

        this.store.commit( 'order/SET_STATE_PROP_VALUE', payload);

        // SERVICE STATE init
        const acceptedStates = [
          nameOf(() => this.store.state.orderFalseDriver),
          nameOf(() => this.store.state.orderTrueDriver),
          nameOf(() => this.store.state.orderFalseRoundTrip),
          nameOf(() => this.store.state.orderTrueRoundTrip),
        ];

        if (! acceptedStates.includes(stateData.stateName)) {
          throw Error('State is not accepted');
        }

        payload = <{prop: string, value: any}[]>[];

        data = stateData.state;
        for (const prop in data) {
          if (! data.hasOwnProperty(prop)) {
            continue;
          }
          payload.push({
            prop, value: data[prop]
          });
        }

        this.store.commit( stateData.stateName + '/SET_STATE_PROP_VALUE', payload);

        switch (stateData.stateName) {
          case nameOf(() => this.store.state.orderFalseDriver):
            this.$router.push(routesConst.CHOOSE_VEHICLE);
            break;

          case nameOf(() => this.store.state.orderTrueDriver):
            this.$router.push(routesConst.CHOOSE_CUSTOM_ROUTE);
            break;

          case nameOf(() => this.store.state.orderFalseRoundTrip):
            this.$router.push(routesConst.TRIPS);
            break;

          case nameOf(() => this.store.state.orderTrueRoundTrip):
            this.$router.push(routesConst.ROUND_TRIP_FIRST_STEP);
            break;
        }
      }
    }
  },
  created(): void {
    axios.get(apiService.generalEndpoint())
        .then(response => {

          const responseData: IApiResponseGeneral = response.data;
          // General

          // Update locale only if it's not already set from the user's local storage
          const locale = this.store.state.general.locale;
          if (! locale) {
            this.store.commit('general/SET_LOCALE', responseData.locale);
          }
          this.store.commit('general/SET_LANGUAGES', LanguageService.convertAPIObjects(responseData.languages));
          this.store.commit('general/SET_CURRENCY', responseData.currency);
          this.store.commit('general/SET_TAX_CHARGE', responseData.tax_charge);

          // Company
          this.store.commit('company/SET_WEBSITE_NAME', responseData.company.website_name);
          this.store.commit('company/SET_LOGO_URL', responseData.company.logo_url);
          this.store.commit('company/SET_LOGO_MOBILE_URL', responseData.company.logo_mobile_url);
          this.store.commit('company/SET_FAVICON', responseData.company.favicon);
          this.store.commit('company/SET_PHONE_NUMBER', responseData.company.phone_number);
          this.store.commit('company/SET_CONTACT_EMAIL', responseData.company.contact_email);
          this.store.commit('company/SET_WORKING_HOURS', responseData.company.working_hours);
          this.store.commit('company/SET_WORKING_HOURS_FOOTER', responseData.company.working_hours_footer);
          this.store.commit('company/SET_COMPANY_NAME', responseData.company.company_name);
          this.store.commit('company/SET_COMPANY_ADDRESS', responseData.company.company_address);
          this.store.commit('company/SET_COMPANY_CODE', responseData.company.company_code);
          this.store.commit('company/SET_VAT_CODE', responseData.company.vat_code);
          this.store.commit('company/SET_INFO_MAIL', responseData.company.info_mail);
          this.store.commit('company/SET_BANK_ACCOUNT', responseData.company.bank_account);
          this.store.commit('company/SET_FINANCE_PHONE', responseData.company.finance_phone);
          this.store.commit('company/SET_DIRECTOR_PHONE', responseData.company.director_phone);
          this.store.commit('company/SET_PURCHASE_DECLARATION', responseData.company.purchase_declaration);
          this.store.commit('company/SET_COOKIES_CONSENT', responseData.company.cookies_consent);
          this.store.commit('company/SET_PRIVACY_POLICY', responseData.company.privacy_policy);
          this.store.commit('company/SET_HOMEPAGE_VIDEO', responseData.company.homepage_video);
          this.store.commit('company/SET_RENT_SERVICE_WITHOUT_DRIVER_DEFAULT_ADDRESS', responseData.company.rent_service_without_driver_default_address);
          // this.store.commit('company/SET_FACEBOOK', responseData.company.facebook);
          // this.store.commit('company/SET_TWITTER', responseData.company.twitter);
          // this.store.commit('company/SET_INSTAGRAM', responseData.company.instagram);
          // this.store.commit('company/SET_LINKEDIN', responseData.company.linkedin);

          // Ensure Rent service without driver default address if none selected from before
          (new RentService(this.store)).ensureCompanyAddressPreselect(this.store.state.orderFalseDriver);
        })
        .catch(error => {
          console.error(error);
        });

    axios.get(apiService.menuEndpoint())
        .then(response => {
          this.menu = response.data.data;
        })
        .catch(error => {
          console.error(error);
        });

    new authService(this.store, this.$router).init();
    this.handleGivenState();
  },
});
</script>